module.exports = __webpack_public_path__ + "img/christiane-king-untitled.9ef2890.jpg";